import React from 'react';
import {useNavigate} from "react-router-dom";
import {useAuth} from "context/AuthContext";
import Dropdown, {DropdownItem} from "components/Dropdown";
import {CheckCircleIcon, EyeIcon, PencilIcon, SortAscendingIcon, TrashIcon, XCircleIcon} from "@heroicons/react/solid";
import {Trail} from "types/Trail";
import {EyeOffIcon} from "@heroicons/react/outline";

// Types ----

type TrailContextMenuProps = {
  trail: Trail
  onReorderTrails: () => void
  onPublishTrail: () => void
  onFeatureTrail: () => void
  onDeleteTrail: () => void
  viewDisabled?: boolean
  editDisabled?: boolean
  reorderDisabled?: boolean
  publishDisabled?: boolean
  featureDisabled?: boolean
  deleteDisabled?: boolean
  position?: 'left' | 'right'
}

// Component ----

function TrailContextMenu({
  trail,
  onReorderTrails,
  onPublishTrail,
  onFeatureTrail,
  onDeleteTrail,
  viewDisabled,
  editDisabled,
  reorderDisabled,
  publishDisabled,
  featureDisabled,
  deleteDisabled,
  position = 'right'
}: TrailContextMenuProps) {
  const navigate = useNavigate();
  const auth = useAuth();

  function viewTrail() {
    void navigate(`/trails/${trail.id}`)
  }

  function editTrail() {
    void navigate(`/trails/${trail.id}/edit`)
  }

  return (
    <Dropdown position={position}>
      {auth.can('trails:read') &&
        <DropdownItem
          name="View"
          icon={EyeIcon}
          onClick={viewTrail}
          disabled={!!viewDisabled}
        />
      }

      {auth.can('trails:write') &&
        <DropdownItem
          name="Edit"
          icon={PencilIcon}
          onClick={editTrail}
          disabled={!!editDisabled}
        />
      }

      {auth.can('trails:write') &&
        <DropdownItem
          name="Reorder"
          icon={SortAscendingIcon}
          onClick={onReorderTrails}
          disabled={!!reorderDisabled}
        />
      }

      {(auth.can('trails:write') || auth.can('trails:publish')) &&
        <DropdownItem
          name={`${trail.is_published ? 'Hide' : 'Publish'}`}
          icon={trail.is_published ? EyeOffIcon : EyeIcon}
          onClick={onPublishTrail}
          disabled={!!publishDisabled}
        />
      }

      {auth.can('trails:write') &&
        <DropdownItem
          name={`${trail.is_featured ? 'Don\'t Feature' : 'Feature'}`}
          icon={trail.is_featured ? XCircleIcon : CheckCircleIcon}
          onClick={onFeatureTrail}
          disabled={!!featureDisabled}
        />
      }

      {auth.can('trails:write') &&
        <DropdownItem
          name="Delete"
          icon={TrashIcon}
          onClick={onDeleteTrail}
          disabled={!!deleteDisabled}
        />
      }
    </Dropdown>
  );
}

export default TrailContextMenu;